<template>
  <div class="flex items-center gap-2 pb-2 w-full justify-between">
    <div class="flex items-center gap-3 min-w-0">
      <router-link :to="link" class="flex items-center flex-grow max-w-fit">
        <Edit v-if="isEdit" class="w-5 h-5 mr-2" />
        <PanelLeft v-else class="w-5 h-5 mr-2" />
        <h1 class="text-sm md:text-lg w-fit">
          {{ title }}
        </h1>
      </router-link>
      <slot />
    </div>
    <div class="flex items-center gap-2">
      <slot name="right" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { PanelLeft, Edit } from 'lucide-vue-next'

import type { RouteLocationRaw } from 'vue-router'

const props = defineProps<{
  title: string
  link: string | RouteLocationRaw
  isEdit?: boolean
}>()
</script>
